import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

export const ThirdPartiesCmp_SomeOrganizations_QueryDocument = graphql(`
  query ThirdPartiesCmp_SomeOrganizations_Query(
    $statusId: Id!
    $isInternal: Boolean!
  ) {
    findSomeOrganizations(
      filter: { statusId: $statusId, isInternal: $isInternal }
    ) {
      _id
      ...ThirdPartiesCmp_Organization_Fragment
    }
  }
`);

export type ThirdPartiesCmp_SomeOrganization = ResultOf<
  typeof ThirdPartiesCmp_SomeOrganizations_QueryDocument
>['findSomeOrganizations'][number];
